import { apiClient } from '~/services/api-service';

export type CreateSupportTicketPayload = {
  name?: string;
  email?: string;
  subject?: string;
  message?: string;
};
const createSupportTicket = (body: CreateSupportTicketPayload) => {
  return apiClient.post('/account/contact/', body);
};

export { createSupportTicket };
